<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaOras')}}</h4>
        </div>
        <form class="add-user-form" id='edit-level1' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group">
                        <div class="selections-option"  @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('tableHeader.judet')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county" :options="counties" label="name"></v-select>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               v-model="input_field.inputValue">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12">
                    <button type="button" @click='saveCity()'>
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CountiesService from '../../api-services/counties.service.js'
import CitiesService from '../../api-services/cities.service.js'
export default {
  name: 'editcity',
  data () {
    return {
      counties: [],
      city: [],
      select_county: null,
      selected_label: null
    }
  },
  methods: {
    getCity () {
      CitiesService.get(this.$route.params.id)
        .then((response) => {
          this.city = response.data.data
          this.getCounties()
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 }).then((response) => {
        this.counties = response.data.data
        this.select_county = this.counties.find(county => county.id === this.city.county.id)
        this.$store.dispatch('hideLoading')
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    },
    saveCity () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-level1'))
      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }

      CitiesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.city = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.orasModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('tableHeader.oras'),
            inputValue: (this.city) ? this.city.name : null,
            icon: 'fas fa-file-signature'
          }
        ]
      }
    }
  },
  created () {
    this.getCity()
  }
}
</script>
